<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="subheader with-padding flgrow">
                <div class="row align-items-center">
                    <div class="col-6 col-lg-3">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <div class="input-group">

                                    <input class="form-control" type="text" name="searchTerm" [(ngModel)]="searchTerm"
                                        (keyup.enter)="onSearchFilter()" placeholder="{{ 'lblSearch' | translate }}"
                                        autocomplete="off" />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                                            <em class="fa fa-search"></em>
                                        </button>
                                    </div>

                                </div>
                            </div>

                            <div class="ml-3">
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-3 col-lg-3 ml-auto d-flex flex-sm-row flex-column justify-content-end align-items-center">

                      
                        <button type="button" type="reset" class="ml-2 add-button btn btn-primary"
                            aria-label="Center Align" *ngIf="userRoleRightsDetails.canAdd" (click)="onAddEdit(0)"
                            translate>lblAddWarningLight</button>
                    </div>
                </div>

            </div>
            <div class="container prel">
                <div class="row">
                    <div class="c12">
                        <div class="card mb-3 scrollbar " [ngClass]="''">
                            <div class="card-header d-flex justify-content-between" translate>
                                lblWarningLight
                                <div class="font16 fontbold">
                                    <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
                                    {{
                                    totalCount
                                    }}
                                    &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                                </div>
                            </div>
                            <div class="table-responsive max-h254" infinite-scroll
                                [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
                                [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                                <table class="tablest1" aria-describedby="mydesc">
                                    <thead>
                                        <tr>
                                            <th style="width:55px" scope="col" translate>#</th>
                                            <th scope="col" style="width:22%" sortable="WarningName"
                                                (sort)="onSort($event)" translate>
                                                lblWarningName</th>
                                            <th scope="col" style="width:40%" translate>
                                                lblWarningDescription</th>
                                            <th scope="col" style="width: 15%" translate>
                                                lblLogo</th>
                                            <th scope="col" style="width: 10%" translate>
                                                    lblIsActive</th>
                                            <th scope="col" translate style="width: 10%" class="text-center">lblAction</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="warningLightList?.length>0; else load_NotFound_Template">
                                            <tr *ngFor="let item of warningLightList; let i=index">
                                                <td>{{ item.rowNumber }}</td>
                                                <td>
                                                    <ngb-highlight [result]="item.warningName">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.warningDescription">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <div class="imgWid">
                                                        <img af-image [data-code]="item.logo"
                                                            [attr.alt]="item.warningName" width="70px">
                                                    </div>
                                                </td>

                                                <td class="">
                                                    <em class="fas fa-check" *ngIf="item.isActive == true; else  load_Else"></em>
                                                    
                                                    <ng-template #load_Else>
                                                        <em class="fas fa-times text-danger"></em>
                                                    </ng-template>
                                                </td>

                                                <td class="nowrap text-center">

                                                    <a class="btn btn-ico" ngbTooltip="Edit"
                                                        tooltipClass="custom-revert"
                                                        *ngIf="userRoleRightsDetails.canEdit"
                                                        (click)="onAddEdit(item.id)">
                                                        <em class="fas fa-pencil-alt fa-lg"></em>
                                                    </a>
                                                    <span class="ico-div"
                                                        *ngIf="userRoleRightsDetails.canDelete"></span>
                                                    <a class="btn btn-ico" ngbTooltip="Delete"
                                                        tooltipClass="custom-revert"
                                                        *ngIf="userRoleRightsDetails.canDelete"
                                                        (click)="deleteWarningLight(item.id)">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                    </a>
                                                </td>
                                            </tr>
                                        </ng-container>
                                        <ng-template #load_NotFound_Template>
                                            <tr>
                                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>